import { TabProps } from '@mui/material';
import React from 'react';
import { StyledTab } from './styles';

export function UITab(props: TabProps) {
  return <StyledTab {...props} />;
}
